import Pusher from 'pusher-js';
import { getAuthToken } from '../utils/auth';
import { api } from './authService';

const PUSHER_KEY = '017198897dfbe96ca1eb';
const PUSHER_CLUSTER = 'eu';

// Use the same API base URL convention as other services
const API_BASE_URL = import.meta.env.VITE_APP_API_URL || (process as any)?.env?.VITE_APP_API_URL;

class PusherService {
  private pusher: Pusher | null = null;

  async initialize(): Promise<void> {
    try {
      const token = getAuthToken();
      console.log('Initializing Pusher with token:', token ? `${token.substring(0, 20)}...` : 'No token');

      this.pusher = new Pusher(PUSHER_KEY, {
        cluster: PUSHER_CLUSTER,
        userAuthentication: {
          endpoint: `${API_BASE_URL}/admin/notification-channel-tokens`,
          transport: 'ajax',
          customHandler: async ({ socketId }, callback) => {
            try {
              console.log('Pusher custom auth handler called with socketId:', socketId);
              const response = await api.post('/admin/notification-channel-tokens', {
                socket_id: socketId
              });
              console.log('Pusher auth response:', response.data);
              callback(null, response.data);
            } catch (error) {
              console.error('Pusher auth error:', error);
              const err = error instanceof Error ? error : new Error('Pusher auth error');
              callback(err, null);
            }
          },
        },
      });

      // Listen for authentication events
      this.pusher.user.bind('pusher:signin_success', () => {
        console.log('Pusher user authentication successful');
      });

      this.pusher.user.bind('pusher:signin_failed', (error: any) => {
        console.error('Pusher user authentication failed:', error);
      });

      // Sign in the user
      this.pusher.signin();

      console.log('Pusher initialized successfully');
    } catch (error) {
      console.error('Error initializing Pusher:', error);
      throw error;
    }
  }

  subscribeToReports(callback: (data: any) => void): void {
    if (!this.pusher) {
      console.error('Pusher not initialized');
      return;
    }

    // Check if user is authenticated
    if (!this.pusher.user) {
      console.error('Pusher user not authenticated');
      return;
    }

    // Bind to the user object for report notifications
    this.pusher.user.bind('report-generated', callback);
    
    console.log('Subscribed to report notifications on user object');
  }

  unsubscribeFromReports(): void {
    if (this.pusher) {
      this.pusher.user.unbind('report-generated');
    }
  }

  disconnect(): void {
    if (this.pusher) {
      this.pusher.disconnect();
      this.pusher = null;
    }
  }
}

export const pusherService = new PusherService();
